module.exports = __webpack_public_path__ + "img/profile-pic.529a94de.svg";